/**
 * Author:hong.rong
 * Desc:优秀案例
 * Date:2022-02-27
 */
import styles from './index.module.less'

import React, { useEffect, useRef } from 'react'

import SP, { Autoplay, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import gioTrackEvent from '@/utils/gio'
import eventMap from '@/utils/gio/eventMap'

SP.use([Navigation, Autoplay])

const slidesPerView: number = 3 // 视口内展示的slideItem数量

export default function Examples({ dataSource, translateTxt, onRouteChange }: any) {
  const length = dataSource?.length
  // const [upList, setUpList] = useState([])
  const upListRef = useRef([])
  const upListClickRef = useRef([])
  // const [alreadyRequest,setAlreadyRequest] = useState(true)

  if (!Array.isArray(dataSource) || length === 0) {
    return null
  }
  const isLoop: boolean = dataSource?.length > slidesPerView

  const onJump = ({ jumpType, jumpUrl, sortNumber }: any) => {
    // 防止只配置图片不配置点击地址的情况
    if (!upListClickRef.current.includes(sortNumber)) {
      gioTrackEvent(eventMap.home_button_click_cz, {
        button_name: sortNumber,
      })
      upListClickRef.current.push(sortNumber)
    }
    // 新增不跳转类型
    if (`${jumpType}` === '0' || !jumpUrl) {
      return
    }
    //  jumpType 1内部页面 2外部链接
    if (`${jumpType}` === '2') {
      window.open(jumpUrl)
    } else {
      onRouteChange(jumpUrl)
    }
  }

  const options = {
    root: null, // 使用浏览器视窗作为根节点
    rootMargin: '0px', // 根节点的边距
    threshold: 0.1, // 目标元素露出百分之10时触发回调
  }

  /**
   * 埋点通用事件
   * @param list
   */
  const handleEventTrack = (list: any[]) => {
    if (Array.isArray(list)) {
      const sortNumber = list?.[0]?.sortNumber
      const sortNumber1 = list?.[1]?.sortNumber
      const sortNumber2 = list?.[2]?.sortNumber
      gioTrackEvent(eventMap.home_button_exposure_cz, {
        button_name: `${sortNumber},${sortNumber1},${sortNumber2}`,
      })
      // setAlreadyRequest(false)
      upListRef.current.push(sortNumber, sortNumber1, sortNumber2)
    }
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const exposureLabel = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        // 当目标元素进入视窗时触发的回调函数
        if (entry.isIntersecting) {
          if (Array.isArray(upListRef.current) && upListRef.current.length === 0) {
            handleEventTrack(dataSource)
          }
        }
      })
    }, options)
    const element = document?.querySelector(`.swiperArea`)
    exposureLabel.observe(element)
  }, [])

  // 轮播执行的逻辑
  const onSetTransition = swiper => {
    const exposureLabel = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        // 当目标元素进入视窗时触发的回调函数
        if (entry.isIntersecting && Array.isArray(swiper?.slides)) {
          for (let i = 0; i < swiper.slides.length; i++) {
            const slide = swiper.slides.eq(i)
            const firstSlide = slide[0] || {}
            if (firstSlide?.className?.includes('swiper-slide-active')) {
              if (Array.isArray(upListRef.current) && upListRef.current.length === 0) {
                handleEventTrack(dataSource)
              } else {
                // 否则有上报，过滤已经上报过的
                const dataId = firstSlide?.dataset?.id
                if (!upListRef.current.includes(Number(dataId))) {
                  // 没有就接着上报
                  gioTrackEvent(eventMap.home_button_exposure_cz, {
                    button_name: dataId,
                  })
                  upListRef.current.push(Number(dataId))
                }
              }
            }
          }
        }
      })
    }, options)
    const element = document?.querySelector(`.swiperArea`)
    exposureLabel.observe(element)
  }

  return (
    <div className={`${styles.cases} swiperArea`}>
      <Swiper
        allowTouchMove={false}
        spaceBetween={25}
        slidesPerView={slidesPerView}
        loop={isLoop}
        onSetTransition={onSetTransition}
        autoplay={
          isLoop
            ? {
                delay: 2000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }
            : false
        }
      >
        {dataSource.map(item => (
          <SwiperSlide key={item.id} className={styles['slider-item']} data-id={item?.sortNumber}>
            <img
              draggable={false}
              loading="lazy"
              src={item?.bannerImage?.url || ''}
              // src={`${item.imageUrl}?x-oss-process=image/format,jpg/quality,q_75`}
              alt={translateTxt('dashboard:t20')}
              className={`bannerButton${item?.sortNumber}`}
              onClick={() => onJump(item)}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
